import React from "react";
import { twMerge } from "tailwind-merge";

export interface ButtonProps extends React.ComponentPropsWithoutRef<"button"> {
  variant?: "primary" | "secondary" | "ghost" | "link";
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  logoOnly?: boolean;
}

const Button = React.forwardRef(
  (
    {
      variant = "primary",
      size = "md",
      logoOnly = false,
      className,
      children,
      ...rest
    }: ButtonProps,
    ref: React.Ref<HTMLButtonElement>
  ) => {
    return (
      <button
        ref={ref}
        className={twMerge(
          "flex justify-center items-center font-medium focus:outline-none transition-colors rounded-lg",
          size === "xs" && "px-2 text-2xs h-6",
          size === "sm" && "px-3 text-xs h-8",
          size === "md" && "px-3 text-sm h-10",
          size === "lg" && "px-4 text-base h-12",
          size === "xl" && "px-6 text-lg h-16",
          variant === "primary" &&
            "bg-primary-600 text-white hover:bg-primary-500 focus:ring-4 focus:ring-primary-300",
          variant === "secondary" &&
            "bg-secondary-200 text-secondary-900 hover:bg-secondary-100 focus:ring-4 focus:ring-secondary-300",
          variant === "ghost" &&
            "bg-transparent text-primary-600 dark:text-white hover:bg-secondary-100 focus:ring-4 focus:ring-secondary-300 dark:hover:bg-secondary-700 dark:focus:ring-secondary-800",
          variant === "link" && "text-primary-600 px-0 hover:text-primary-500",
          logoOnly && size === "xs" && "p-0 w-6",
          logoOnly && size === "sm" && "p-0 w-8",
          logoOnly && size === "md" && "p-0 w-10",
          logoOnly && size === "lg" && "p-0 w-12",
          logoOnly && size === "xl" && "p-0 w-16",
          className
        )}
        {...rest}
      >
        {children}
      </button>
    );
  }
);

export default Button;
